import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer,
} from "recharts";
import "./Type.css";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
// import { fetchAppointmentTypes } from "src/redux/slices/appointmentTypeSlice"; // adjust path
import { fetchAppointmentTypes } from "../../../../redux/reducers/appointmentTypeSlice";
function AppointType() {
  const dispatch = useDispatch();
  const { typeOfAppointment, reschedulingRate, patientWaitTime, loading } = useSelector(
    (state) => state.appointmentTypes
  );

  const [view, setView] = useState("Weekly");
  const [donutSeries, setDonutSeries] = useState([]);
  const [donutLabels, setDonutLabels] = useState([]);
  const [barData, setBarData] = useState([]);
  const [boxPlotSeries, setBoxPlotSeries] = useState([]);

  useEffect(() => {
    dispatch(fetchAppointmentTypes());
  }, [dispatch]);

  // useEffect(() => {
  //   if (loading) return;

  //   // Donut Chart Data
  //   const labels = Object.keys(typeOfAppointment);
  //   const series = Object.values(typeOfAppointment);
  //   setDonutLabels(labels);
  //   setDonutSeries(series);

  //   // Bar Chart Data (Example static for now - can be fetched dynamically)
  //   setBarData([
  //     { month: "Jan", noShows: 14, late: 10, resched: 7 },
  //     { month: "Feb", noShows: 13, late: 6, resched: 9 },
  //     { month: "Mar", noShows: 11, late: 9, resched: 6 },
  //     { month: "Apr", noShows: 8, late: 5, resched: 12 },
  //     { month: "May", noShows: 10, late: 6, resched: 9 },
  //   ]);

  //   // Box Plot Data
  //   const waitTime2025 = patientWaitTime["2025"] || [];
  //   const formattedBoxData = waitTime2025.map((item) => ({
  //     x: item.month,
  //     y: [item.min, item.q1, item.median, item.q3, item.max], // Example format
  //   }));

  //   setBoxPlotSeries([{
  //     type: "boxPlot",
  //     data: formattedBoxData.length > 0 ? formattedBoxData : [
  //       { x: "Jan", y: [5, 10, 15, 20, 30] },
  //       { x: "Feb", y: [10, 15, 20, 25, 35] },
  //       { x: "Mar", y: [15, 25, 35, 45, 60] },
  //       { x: "Apr", y: [10, 20, 25, 35, 45] },
  //       { x: "May", y: [8, 12, 20, 28, 40] },
  //     ],
  //   }]);

  // }, [typeOfAppointment, patientWaitTime, loading]);

  // Donut Chart Options
  
  useEffect(() => {
  if (loading) return;

  // Donut Chart Data
  const labels = Object.keys(typeOfAppointment);
  const series = Object.values(typeOfAppointment);
  setDonutLabels(labels);
  setDonutSeries(series);

  // Bar Chart Data - only use real data from reschedulingRate
  if (Array.isArray(reschedulingRate) && reschedulingRate.length > 0) {
    setBarData(reschedulingRate);
  } else {
    setBarData([]); // Clear data if none available
  }

  // Box Plot Data - only use real data from patientWaitTime
  const waitTime2025 = patientWaitTime["2025"] || [];
  if (Array.isArray(waitTime2025) && waitTime2025.length > 0) {
    const formattedBoxData = waitTime2025.map((item) => ({
      x: item.month,
      y: [item.min, item.q1, item.median, item.q3, item.max],
    }));
    setBoxPlotSeries([{
      type: "boxPlot",
      data: formattedBoxData,
    }]);
  } else {
    setBoxPlotSeries([]); // Clear data if none available
  }

}, [typeOfAppointment, reschedulingRate, patientWaitTime, loading]);

  const donutOptions = {
    chart: { type: "donut" },
    labels: donutLabels,
    colors: ["#1D4ED8", "#9333EA", "#8B5CF6", "#06B6D4", "#A78BFA", "#EC4899", "#FBBF24", "#34D399"],
    legend: { show: false },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${Math.round(val)}%`,
    },
    plotOptions: {
      pie: {
        donut: { size: "70%" },
      },
    },
  };

  // Bar Chart
  const barColors = {
    noShows: "#EF4444",
    late: "#FACC15",
    resched: "#FFB71B"
  };

  // Box Plot Chart
  const boxOptions = {
    chart: {
      type: "boxPlot",
      toolbar: { show: false },
    },
    xaxis: {
      categories: boxPlotSeries[0]?.data.map(d => d.x) || [],
    },
  };

  return (
    <div className="dashboard-container">
      {/* Type of Appointment (Donut Chart) */}
      <div className="donut-box">
        <div className="donut-header">
          <h3>Type of Appointment</h3>
          <select>
            <option>Feb</option>
            <option>Mar</option>
            <option>Apr</option>
          </select>
        </div>
        {/* <Chart options={donutOptions} series={donutSeries} type="donut" height={250} /> */}
       {donutSeries.length > 0 ? (
  <Chart options={donutOptions} series={donutSeries} type="donut" height={250} />
) : (
  <p>No data available for appointment types.</p>
)}
        <ul className="donut-legend">
          {donutLabels.map((label, index) => (
            <li key={index}>
              <span className={`dot dot${index + 1}`} style={{ backgroundColor: donutOptions.colors[index] }} />
              {label} - {donutSeries[index]}
            </li>
          ))}
        </ul>
      </div>

      {/* Right Section */}
      <div className="right-section">
        {/* No-show / Rescheduling Rate (Bar Chart) */}
        <div className="bar-box">
          <div className="bar-header">
            <h3>Appointment No-show/Rescheduling Rate</h3>
            <ToggleButtonGroup
              value={view}
              exclusive
              onChange={(_, val) => val && setView(val)}
              size="small"
              sx={{
                backgroundColor: '#f0f2f5',
                borderRadius: '12px',
                '& .MuiToggleButtonGroup-grouped': {
                  borderRadius: '7px',
                  borderColor: 'transparent',
                  color: '#333',
                  fontWeight: 500,
                  '&.Mui-selected': {
                    backgroundColor: '#005EB8',
                    color: '#fff',
                  },
                },
              }}
            >
              <ToggleButton value="Weekly">Week</ToggleButton>
              <ToggleButton value="Monthly">Month</ToggleButton>
              <ToggleButton value="Yearly">Year</ToggleButton>
            </ToggleButtonGroup>
          </div>
          {/* <ResponsiveContainer width="100%" height={250}>
            <BarChart data={barData}>
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="noShows" fill={barColors.noShows} name="No-shows" barSize={20} radius={[10, 10, 0, 0]} />
              <Bar dataKey="late" fill={barColors.late} name="Late arrivals" barSize={20} radius={[10, 10, 0, 0]} />
              <Bar dataKey="resched" fill={barColors.resched} name="Rescheduled" barSize={20} radius={[10, 10, 0, 0]} />
            </BarChart>
          </ResponsiveContainer> */}
          {barData.length > 0 ? (
  <ResponsiveContainer width="100%" height={250}>
            <BarChart data={barData}>
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="noShows" fill={barColors.noShows} name="No-shows" barSize={20} radius={[10, 10, 0, 0]} />
              <Bar dataKey="late" fill={barColors.late} name="Late arrivals" barSize={20} radius={[10, 10, 0, 0]} />
              <Bar dataKey="resched" fill={barColors.resched} name="Rescheduled" barSize={20} radius={[10, 10, 0, 0]} />
            </BarChart>
  </ResponsiveContainer>
) : (
  <p>No data available for rescheduling rates.</p>
)}
        </div>

        {/* Patient Wait Time (Box Plot) */}
        <div className="boxplot-box">
          <div className="box-header">
            <h3>Patient Wait Time</h3>
            <select>
              <option>2024</option>
              <option>2023</option>
            </select>
          </div>
          {/* <Chart options={boxOptions} series={boxPlotSeries} type="boxPlot" height={250} /> */}
      {boxPlotSeries.length > 0 && boxPlotSeries[0].data.length > 0 ? (
  <Chart options={boxOptions} series={boxPlotSeries} type="boxPlot" height={250} />
) : (
  <p>No data available for patient wait times.</p>
)}
        </div>
      </div>
    </div>
  );
}

export default AppointType;
